import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { mediaSrc } from './services/mediaAssets';
import './firebase';
import store from './store';
import vuetify from './plugins/vuetify';
import './styles/global.scss'; // Adjust the path as necessary

if (process.env.NODE_ENV !== 'production') {
  Promise.all([
    import('./data/reckon-way/events'),
    import('./data/reckon-way/entities'),
    import('./content/culture/eats'),
    import('./lib/reckon-way/contentAudit'),
  ]).then(([eventsModule, entitiesModule, eatsModule, auditModule]) => {
    const issues = auditModule.auditReckonWayContent({
      events: eventsModule.reckonWayEvents,
      entityById: entitiesModule.experienceEntityById,
      eats: eatsModule.eats,
    });
    auditModule.reportReckonWayAudit(issues);
  });
}

Vue.config.productionTip = false;
Vue.filter('mediaSrc', mediaSrc);
store.dispatch('initializeAuth');

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
